export class Ticket {
  Id: number;
  Note: string;
  UserId?: number;
  UserFirstName?: string;
  UserLastName?: string;
  UserUsername?: string;
  UserEmail?: string;
  SiteId: number;
  SiteName?: string;
  DeviceName?: string;
  TechnicianId?: number;
  TechnicianFirstName?: string;
  TechnicianLastName?: string;
  TechnicianUsername?: string;
  TechnicianEmail?: string;
  FlagClosed: boolean;
  TotalAccess: boolean;
  TotalAccessExpDate: string | Date;
  ClosingDate?: string | Date;
  UpdatedAt?: string | Date;
  CreatedAt?: string | Date;
  ClosingNote?: string;
}

export const openedTotalAccess = (t: Ticket): boolean => t.TotalAccess && !t.FlagClosed;
